<mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSort matSortDisableClear matSortDirection="asc" 
aria-label="Attendance Data Table" tabindex="0" style="min-width: 870px;">
    <ng-container matColumnDef="More">
      <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"><span translate>More</span></mat-header-cell>
      <mat-cell *matCellDef="let teamAttend" style="min-width:68px;max-width:68px;text-align:center;color:black;">
          <span *ngIf="teamAttend.StudentTeamAttendanceDetails.length > 0" aria-label="Expand row for more details">
              <i [ngClass]="checkExpanded(teamAttend) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                  aria-hidden="true"></i>
          </span>
      </mat-cell>
  </ng-container>
  <ng-container matColumnDef="stName">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;max-width: 450px;">
        <span translate>Team Name</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="stName" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let teamAttend" style="min-width: 100px;max-width: 450px;">{{teamAttend.stName}}</mat-cell>
</ng-container>
<ng-container matColumnDef="staffName">
  <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;max-width: 450px;">
      <span translate>Staff</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="staffName" dataType="string"></filter>
  </mat-header-cell>
  <mat-cell *matCellDef="let teamAttend" style="min-width: 100px;max-width: 450px;">{{teamAttend.staffName}}</mat-cell>
</ng-container>
<ng-container matColumnDef="aCount">
  <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;max-width: 450px;">
      <span translate>A</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="aCount" dataType="string"></filter>
  </mat-header-cell>
  <mat-cell *matCellDef="let teamAttend" style="min-width: 100px;max-width: 450px;">{{teamAttend.aCount}}</mat-cell>
</ng-container>
<ng-container matColumnDef="tCount">
  <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;max-width: 450px;">
      <span translate>T</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="tCount" dataType="string"></filter>
  </mat-header-cell>
  <mat-cell *matCellDef="let teamAttend" style="min-width: 100px;max-width: 450px;">{{teamAttend.tCount}}</mat-cell>
</ng-container>
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let teamAttend" [attr.colspan]="columnsToDisplayTeamAttendance.length" style="width:100%;" class="mat-detail-card">
          <div>
              <app-by-team-details [attendanceDetails]="teamAttend.StudentTeamAttendanceDetails"></app-by-team-details>
          </div>
      </td>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columnsToDisplayTeamAttendance; sticky:true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columnsToDisplayTeamAttendance" [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
      tabindex="0" [attr.aria-label]="getAriaRowByTeamAttendance(row)" style="padding:0px;overflow: hidden;" matRipple
      (click)="toggleExpanded(row)" (keydown)="rowKeyPress($event, row)">
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['expandedDetail']" [@detailExpand]="checkExpanded(row) && row.StudentTeamAttendanceDetails.length > 0 ? 'expanded' : 'collapsed'"
      (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
      (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null" style="overflow: hidden"
      class="mat-detail-row">
  </mat-row>
</mat-table>